import {styled} from "@mui/material/styles"
import {breakpoints} from "@next/themes"

export const StandardFacetListButtonText = styled("span")<{$isOnSecondRow?: boolean}>`
    white-space: nowrap;
    max-width: ${({$isOnSecondRow}) => ($isOnSecondRow ? `12rem` : `6rem`)};
    overflow-x: hidden;
    text-overflow: ellipsis;
    @media (max-width: ${breakpoints.values.xl}px) {
        max-width: ${({$isOnSecondRow}) => ($isOnSecondRow ? `10rem` : `4.3rem`)};
    }
`
export default StandardFacetListButtonText
